<!-- Topbar -->
<div class="flex items-center py-3 px-4 border-b border-[#E3E3E3]">
    <button type="button"
        class="lg:hidden inline-flex items-center justify-center w-10 h-10 rounded-lg mr-2 hover:bg-gray-100 transition"
        (click)="openSidebar()">
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="18" viewBox="0 0 25 18" fill="none">
            <path d="M1.5 1.5H23.5H1.5ZM1.5 9C10.0915 9 14.9085 9 23.5 9H1.5ZM1.5 16.5H23.5H1.5Z" fill="#FE354E" />
            <path d="M1.5 1.5H23.5M1.5 9C10.0915 9 14.9085 9 23.5 9M1.5 16.5H23.5" stroke="#0DAC57" stroke-width="3"
                stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    </button>

    <h2 class="text-[#1F1F1F] text-lg md:text-2xl font-medium">
        {{ uiService.selectedRouteLabel }}
    </h2>

    <div class="flex-1 flex items-center justify-end gap-3 md:gap-5">
        <div class="relative hidden md:block w-[200px] lg:w-[243px]">
            <input type="text" placeholder="Search"
                class="rounded-xl border border-[#ddd] bg-white w-full h-[42px] pl-4 pr-10 outline-none focus:ring-1 focus:ring-sgm-primary-base text-sm" />
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 25" fill="none"
                class="absolute top-1/2 -translate-y-1/2 right-3">
                <path
                    d="M11.5 22.25C5.85 22.25 1.25 17.65 1.25 12C1.25 6.35 5.85 1.75 11.5 1.75C17.15 1.75 21.75 6.35 21.75 12C21.75 17.65 17.15 22.25 11.5 22.25ZM22 23.251L19.47 21.031"
                    stroke="#8F8F8F" stroke-width="1.5" stroke-linecap="round" />
            </svg>
        </div>

        <button>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 46 47" fill="none">
                <path
                    d="M11.5 36.9167V19.6667C11.5 13.3154 16.6487 8.16666 23 8.16666V8.16666C29.3512 8.16666 34.5 13.3154 34.5 19.6667V36.9167M11.5 36.9167H34.5M11.5 36.9167H7.66663M34.5 36.9167H38.3333"
                    stroke="#0DAC57" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M21.0833 42.6667L24.9166 42.6667" stroke="#0DAC57" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                <circle cx="23" cy="6.25001" r="1.91667" stroke="#0DAC57" stroke-width="2" />
            </svg>
        </button>

        <div class="relative inline-flex">
            <button (click)="toggleMenu()"
                class="inline-flex items-center justify-center w-[42px] h-[42px] rounded-full overflow-hidden hover:bg-gray-100 transition">
                <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 46 47" fill="none">
                    <rect y="0.5" width="46" height="46" rx="23" fill="#CFEEDD" />
                    <path
                        d="M23.2564 22.2461C23.1353 22.234 22.9899 22.234 22.8566 22.2461C19.9732 22.1492 17.6835 19.7867 17.6835 16.8791C17.6835 13.9109 20.0823 11.5 23.0626 11.5C26.0308 11.5 28.4417 13.9109 28.4417 16.8791C28.4296 19.7867 26.1398 22.1492 23.2564 22.2461Z"
                        stroke="#0DAC57" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M17.1989 26.7166C14.267 28.6792 14.267 31.8776 17.1989 33.8281C20.5305 36.0573 25.9944 36.0573 29.3261 33.8281C32.2579 31.8655 32.2579 28.6671 29.3261 26.7166C26.0066 24.4995 20.5427 24.4995 17.1989 26.7166Z"
                        stroke="#0DAC57" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>

            <div #adminAuthMenu *ngIf="isMenuOpen"
                class="absolute bg-white right-0 top-full rounded-lg min-w-[240px] z-[9999] shadow-[0_12px_16px_-4px_rgba(15,23,42,0.10),0_4px_6px_-2px_rgba(15,23,42,0.05)] overflow-hidden">
                <div class="p-3 text-sgm-neutral-900 font-bold border-b border-[#F1F5F9]">
                    Account menu
                </div>
                <div class="flex flex-col">
                    <button
                        class="flex items-center gap-3 px-4 py-2 text-sm text-sgm-neutral-900 hover:bg-slate-100 w-full text-left transition">

                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.3334 14V12.6667C13.3334 11.9594 13.0525 11.2811 12.5524 10.781C12.0523 10.281 11.374 10 10.6667 10H5.33341C4.62617 10 3.94789 10.281 3.4478 10.781C2.9477 11.2811 2.66675 11.9594 2.66675 12.6667V14M10.6667 4.66667C10.6667 6.13943 9.47284 7.33333 8.00008 7.33333C6.52732 7.33333 5.33341 6.13943 5.33341 4.66667C5.33341 3.19391 6.52732 2 8.00008 2C9.47284 2 10.6667 3.19391 10.6667 4.66667Z" stroke="#0F172A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>

                        <span class="flex-1">Profile</span>
                    </button>
                    <button (click)="logout()"
                        class="flex items-center gap-3 px-4 py-2 text-sm text-[#B3261E] hover:bg-slate-100 w-full text-left transition">

                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 2H12.6667C13.0203 2 13.3594 2.14048 13.6095 2.39052C13.8595 2.64057 14 2.97971 14 3.33333V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H10M6.66667 11.3333L10 8M10 8L6.66667 4.66667M10 8H2" stroke="#B3261E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>

                        <span class="flex-1">Log out</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
